"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSkiId = exports.StyledTitle = exports.StyledImage = exports.StyledBlock = exports.StyledProductCard = exports.generalText = void 0;
const ui_components_1 = require("@groupby/ui-components");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const styled_components_1 = __importStar(require("styled-components"));
const { primaryGreen200, white } = ui_components_1.baseColors;
exports.generalText = (0, styled_components_1.css) `
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.75rem;
`;
exports.StyledProductCard = styled_components_1.default.div `
  width: 7.5rem;
  height: 10rem;
  border-radius: 0.3rem;
  cursor: pointer;
  position: relative;
  background: ${white};
  transition: all .3s;
  border: 0.1rem solid ${({ isChecked }) => (isChecked ? primaryGreen200 : '#D9D9D9')};
  &:after {
    content: '';
    width: 1.5rem;
    height: 1.5rem;
    background: ${({ isChecked }) => (isChecked ? primaryGreen200 : '#D9D9D9')};
    position: absolute;
    top: -0.125rem;
    right: -0.125rem;
    border-radius: 0.25rem;
  }

  & svg {
    position: absolute;
    right: 0.187rem;
    top: 0.312rem;
    z-index: 1;
  }

  {
    ${({ isChecked }) => !isChecked
    && (0, styled_components_1.css) `
        ${exports.generalText} {
          color: #D9D9D9;
        }
      `}
  }
`;
exports.StyledBlock = styled_components_1.default.div `
  font-size: 0.75rem;
  padding: 0 0.312rem;
`;
exports.StyledImage = styled_components_1.default.div `
  width: 7.5rem;
  height: 7.1rem;
  background: url(${({ image }) => (image || '')});
  background-size: contain;
  background-position: center;
`;
exports.StyledTitle = (0, styled_components_1.default)(Typography_1.default) `
  ${exports.generalText}
`;
exports.StyledSkiId = (0, styled_components_1.default)(Typography_1.default) `
  ${exports.generalText}
`;
